var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "process-apply-container"
  }, [_c('fm-generate-antd-form', {
    ref: "generateForm",
    attrs: {
      "data": _vm.jsonData
    }
  }), _c('a-card', {
    staticClass: "cards",
    attrs: {
      "bordered": false
    }
  }, [_c('div', {
    staticClass: "hyd-drawer-select-person"
  }, [_c('div', [_vm._v("设置抄送人")]), _c('select-person', {
    ref: "selectGroups",
    attrs: {
      "tabList": _vm.usersTabList,
      "width": "100%"
    },
    model: {
      value: _vm.usersList,
      callback: function callback($$v) {
        _vm.usersList = $$v;
      },
      expression: "usersList"
    }
  })], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };